import React from 'react'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { IGatsbyChildImageSharp } from '@et/types/Gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { GATSBYIMGLOADING } from '@et/types/Enums'

interface IPadImgProps {
  img: {
    gatsbyImageData: IGatsbyImageData
  }
  iPadImg: {
    gatsbyImageData: IGatsbyImageData
  }
  alt: string
}

function IPadImgV4 ({ iPadImg, alt, img }: IPadImgProps) {
  return (
    <ImgContainer>
      <div className='device3-art v4'>
        <GatsbyImage alt={alt} image={img.gatsbyImageData} loading={GATSBYIMGLOADING.LAZY}/>
      </div>
      <GatsbyImage alt={`Every-tuesday IPad Online course`} image={iPadImg.gatsbyImageData}
                   loading={GATSBYIMGLOADING.LAZY}/>
    </ImgContainer>
  )
}

const ImgContainer = styled.div`
  position: relative;
  
  .device3-art{
    overflow: hidden;
    position: absolute;
    top: -4%;
    left: -2.5%;
    transform: scale(0.8);
    z-index: 5;
    width: 100%;
    @media ${device.laptop}{
      max-width: 920px;
      top: -21px;
      left: -15px;
      transform: scale(0.83);
    }    
    @media ${device.laptopL}{
      max-width: none;
      top: -34px;
      left: -29px;
      transform: scale(.8);
    }
    img{
      width: 100%;
    }
  }
`
export default IPadImgV4
